module.exports = __webpack_public_path__ + "media/icons/email-40d7f299.svg";